// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import "@store/Framework/Store";
import starterReducer from "@store/Framework/Store/Starter/StarterReducer";
import foundationReducer, { FoundationActions } from "@store/Framework/Store/Foundation/FoundationReducer";

(reducers as any).starter = starterReducer;

/* Store Custom Code - Start */
import bunzlReducer, { BunzlActions } from "@store/Framework/Store/Bunzl/BunzlReducer";
/* Store Custom Code - End */

export type BunzlAnyAction = BunzlActions;
export type FoundationAnyAction = FoundationActions;

(reducers as any).bunzl = bunzlReducer;
(reducers as any).foundation = foundationReducer;
